import { FormEvent, useState } from 'react'
import { api, ApiError } from '../lib/api'
import { Alert } from './states'

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function NewsletterForm() {
  const [firstName, setFirstName] = useState('')
  const [email, setEmail] = useState('')
  const [website, setWebsite] = useState('')
  const [state, setState] = useState<'idle' | 'invalid' | 'busy' | 'done' | 'failed'>('idle')
  const nameBad = state === 'invalid' && !firstName.trim()
  const emailBad = state === 'invalid' && !EMAIL.test(email.trim())
  const [failure, setFailure] = useState('')

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    if (!firstName.trim() || !EMAIL.test(email.trim())) return setState('invalid')
    setState('busy')
    try {
      await api.post('/api/newsletter/subscribe', { firstName: firstName.trim(), email: email.trim(), website })
      setState('done')
    } catch (error) {
      setFailure(error instanceof ApiError && error.status !== 0 ? error.message : 'Please try again in a moment.')
      setState('failed')
    }
  }

  return (
    <form className="newsletter" onSubmit={submit} noValidate>
      <h2 className="h3">Join the newsletter</h2>
      <p className="lead">
        New comics and the occasional note from the artist, straight to your inbox.
      </p>
      {state === 'done' ? (
        <Alert tone="ok" title="Check your inbox.">
          Thanks, {firstName.trim()}. Confirm your subscription by clicking on the link sent to {email.trim()}. If you have already subscribed with this email address, you won't receive another confirmation email.
        </Alert>
      ) : (
        <>
          <div className="row-inline">
            <label htmlFor="nl-name" className="vh">
              First name
            </label>
            <input
              id="nl-name"
              className={nameBad ? 'field err name' : 'field name'}
              type="text"
              autoComplete="given-name"
              placeholder="First name"
              value={firstName}
              maxLength={50}
              disabled={state === 'busy'}
              aria-invalid={nameBad}
              aria-describedby={nameBad ? 'nl-name-err' : undefined}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <label htmlFor="nl-email" className="vh">
              Email address
            </label>
            <input
              id="nl-email"
              className={emailBad ? 'field err' : 'field'}
              type="email"
              autoComplete="email"
              placeholder="Email address"
              value={email}
              disabled={state === 'busy'}
              aria-invalid={emailBad}
              aria-describedby={emailBad ? 'nl-err' : undefined}
              onChange={(e) => setEmail(e.target.value)}
            />
            {/* Hidden from people; bots fill it in */}
            <input className="vh" tabIndex={-1} autoComplete="off" aria-hidden="true" name="website" value={website} onChange={(e) => setWebsite(e.target.value)} />
            <button type="submit" className="btn solid" disabled={state === 'busy'}>
              {state === 'busy' && <span className="spin" aria-hidden="true" />}
              {state === 'busy' ? 'Subscribing' : 'Subscribe'}
            </button>
          </div>
          {nameBad && (
            <div id="nl-name-err" className="ferr" role="alert">
              Enter your first name.
            </div>
          )}
          {emailBad && (
            <div id="nl-err" className="ferr" role="alert">
              Enter a valid email address.
            </div>
          )}
          {state === 'failed' && <Alert title="We couldn't subscribe you.">{failure}</Alert>}
        </>
      )}
    </form>
  )
}
